// 引入封装的request.js文件
import request from '@/request'

// 查询-get类型
export function dataDisplayList(data) {
    return request({
        url: '/dataDisplay/list'.trim(),
        method: 'get',
        params: data
    })
}

// 登录
export function login(data) {
    return request({
        url: '/admin/user/login'.trim(),
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}
// 添加公司
export function addcompany(data) {
    return request({
        url: '/admin/company/create'.trim(),
        method: 'post',
        params: data
    })
}
// 公司列表/admin/company/list?page=1&per_page=15
export function companyList(data) {
    return request({
        url: '/admin/company/list'.trim(),
        method: 'get',
        params: data
    })
}
// 公司详情/admin/company/productInfo?company_id=1
export function companyDetail(data) {
    return request({
        url: '/admin/company/productInfo'.trim(),
        method: 'get',
        params: data
    })
}
// 添加公司产品/admin/company/createProduct
export function addcompanyProduct(data) {
    return request({
        url: '/admin/company/createProduct'.trim(),
        method: 'post',
        params: data
    })
}
// 账户列表/admin/companyAccount/accountList?company_id=208568
export function accountList(data) {
    return request({
        url: '/admin/companyAccount/accountList'.trim(),
        method: 'get',
        params: data
    })
}
// 账户详情/admin/companyAccount/accountInfo?company_account_id=5
export function accountDetail(data) {
    return request({
        url: '/admin/companyAccount/accountInfo'.trim(),
        method: 'get',
        params: data
    })
}
// 账户配置/admin/companyAccount/accountConfig
export function accountConfig(data) {
    return request({
        url: '/admin/companyAccount/accountConfig'.trim(),
        method: 'post',
        params: data
    })
}
// 账户充值/admin/companyAccount/accountTransfer
export function accountTransfer(data) {
    return request({
        url: '/admin/companyAccount/accountTransfer'.trim(),
        method: 'post',
        data: data
    })
}
// 账户记录/admin/companyAccount/accountRecord?company_account_id=&page=&per_page=15
export function accountRecord(data) {
    return request({
        url: '/admin/companyAccount/accountRecord'.trim(),
        method: 'get',
        params: data
    })
}
// 飞机票订单列表/admin/order/flightList?page=1&per_page=15
export function flightList(data) {
    return request({
        url: '/admin/order/flightList'.trim(),
        method: 'get',
        params: data
    })
}
// 飞机票订单列表（别名，用于组件中调用）
export function flightOrderList(data) {
    return flightList(data)
}

// 酒店订单列表/admin/order/hotelList?page=1&per_page=15
export function hotelList(data) {
    return request({
        url: '/admin/order/hotelList'.trim(),
        method: 'get',
        params: data
    })
}
// 酒店订单列表（别名，用于组件中调用）
export function hotelOrderList(data) {
    return hotelList(data)
}

// 火车票订单列表/admin/order/trainList?page=1&per_page=15
export function trainList(data) {
    return request({
        url: '/admin/order/trainList'.trim(),
        method: 'get',
        params: data
    })
}
// 火车票订单列表（别名，用于组件中调用）
export function trainOrderList(data) {
    return trainList(data)
}

// 美团订单列表/admin/order/meituanList?page=1&per_page=15
export function meituanList(data) {
    return request({
        url: '/admin/order/meituanList'.trim(),
        method: 'get',
        params: data
    })
}
// 美团订单列表（别名，用于组件中调用）
export function meituanOrderList(data) {
    return meituanList(data)
}

// 其他订单列表/admin/order/otherList?page=1&per_page=15
export function otherOrderList(data) {
    return request({
        url: '/admin/order/otherList'.trim(),
        method: 'get',
        params: data
    })
}
// 图片上传接口/admin/common/imageUploads
export function imageUploads(data) {
    return request({
        url: '/admin/common/imageUploads'.trim(),
        method: 'post',
        data: data
    })
}

// 删除-delete类型
export function dataDisplayDelete(id) {
    return request({
        url: `/dataDisplay/delete/${id}`.trim(),
        method: 'delete'
    })
}
// 京东
// 查询消息列表  /api/jd/client/messages?page=1&per_page=20
export function jingdongMessageList(data) {
    return request({
        url: '/jd/client/messages'.trim(),
        method: 'get',
        params: data
    })
}
// 查询消息详情GET /api/jd/client/messages/{messageId}
export function jingdongMessageDetail(data) {
    return request({
        url: `/jd/client/messages/${data.messageId}`.trim(),
        method: 'get',
        params: data
    })
}
// 查询消息统计GET /api/jd/client/messages/statistics
export function jingdongMessageStatistics(data) {
    return request({
        url: '/jd/client/messages/statistics'.trim(),
        method: 'get',
        params: data
    })
}
// 查询京东订单列表 POST /api/jd/orders
export function jingdongOrderList(data) {
    // 确保传递app_key和company-id参数
    const requestData = {
        ...data,
        app_key: 'SkRWT1BXNmROaGJHdlR5Ng==',
        'company-id': '208568'
    }
    return request({
        url: '/admin/order/jdList'.trim(),
        method: 'get',
        params: requestData
    })
}
// ====================================== 用户管理 ======================================
// 用户获取公司列表 getCompanyList
export function getCompanyList(data) {
    return request({
        url: '/admin/company/getCompanyList'.trim(),
        method: 'get',
        params: data
    })
}
// 用户新增/修改 admin/user/register post
export function userRegister(data) {
    return request({
        url: '/admin/user/adminSave'.trim(),
        method: 'post',
        data: data
    })
}
// 获取用户列表 admin/user/getAdminList?limit=10&page=1
export function userList(data) {
    return request({
        url: '/admin/user/getAdminList'.trim(),
        method: 'get',
        params: data
    })
}
// 删除用户 admin/user/destroy/4 delete
export function userDelete(data) {
    return request({
        url: `/admin/user/destroy/${data.id}`.trim(),
        method: 'delete'
    })
}
// ====================================== 角色 ======================================
// 新增角色 admin/menu/roleAdd?title=APP超级管理员&sort=1&slug=super-admin
export function roleAdd(data) {
    return request({
        url: '/admin/menu/roleAdd',
        method: 'post',
        data: data
    })
}
// 编辑角色 admin/menu/roleUpdate?title=APP1超级管理员&sort=1&slug=super-admin&id=1
export function roleUpdate(data) {
    return request({
        url: '/admin/menu/roleUpdate',
        method: 'post',
        data: data
    })
}
// 角色详情 admin/menu/roleDetail?id=1
export function roleDetail(data) {
    return request({
        url: '/admin/menu/roleDetail',
        method: 'get',
        params: data
    })
}
// 角色绑定菜单 admin/menu/setRoleMenu?role_id=1&role_menus=[1,0]
export function roleBindMenu(data) {
    return request({
        url: '/admin/menu/setRoleMenu',
        method: 'post',
        data: data
    })
}
// 获取角色下的菜单 admin/menu/getRoleMenuList?role_id=1
export function roleMenuList(data) {
    return request({
        url: '/admin/menu/getRoleMenuList',
        method: 'get',
        params: data
    })
}
// 角色列表 admin/menu/getRoleList?limit=10&page=1
export function roleList(data) {
    return request({
        url: '/admin/menu/getRoleList',
        method: 'get',
        params: data
    })
}
// ======================================= 菜单 =======================================
// 菜单列表 admin/menu/list
export function menuList(data) {
    return request({
        url: '/admin/menu/list',
        method: 'get',
        params: data
    })
}
// 新增菜单 admin/menu/add?type=1&menu_name=菜单名称&sort=1&route_url=ad,omg/dsii&component_path=dsd&route_param=1&is_show=1&perms=sdd&icon=ssss&parent_id=0
export function menuAdd(data) {
    return request({
        url: '/admin/menu/add',
        method: 'post',
        data: data
    })
}
// 编辑菜单 admin/menu/update?type=1&menu_name=菜单名称1&sort=1&route_url=ad,omg/dsii&component_path=dsd&route_param=1&is_show=1&perms=sdd&icon=ssss&parent_id=0&id=1
export function menuUpdate(data) {
    return request({
        url: '/admin/menu/update',
        method: 'post',
        data: data
    })
}
// 菜单详情 admin/menu/detail?id=2
export function menuDetail(data) {
    return request({
        url: '/admin/menu/detail',
        method: 'get',
        params: data
    })
}
// 删除菜单 admin/menu/delete?id=2 del
export function menuDelete(data) {
    return request({
        url: `/admin/menu/delete`,
        method: 'delete',
        params: data
    })
}
// 重置密码 /admin/user/forgetPwd/4 get
export function resetPassword(data) {
    return request({
        url: `/admin/user/forgetPwd/${data.id}`,
        method: 'get'
    })
}
